import { createFileRoute } from "@tanstack/react-router";
import { KontorPage, kontorHead } from "@/pages/KontorPage";

export const Route = createFileRoute("/brancher/kontor-hovedsaeder")({
  head: () => kontorHead("da"),
  component: () => <KontorPage locale="da" />,
});
